import classNames from 'classnames';
import type { IntlKey } from 'locales';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import type { PriceImprovementStatus } from 'state/quotes/priceEnhancements/priceImprovementRequest/priceImprovementRequest.model';

type Color = 'info' | 'warning' | 'success' | 'secondary' | 'danger';

export const StatusBadge: FC<{ status: PriceImprovementStatus; className?: string }> = ({ status, className }) => {
  const { formatMessage } = useIntl();
  return (
    <span className={classNames(`badge rounded-pill badge-sm badge-discreet-${toColor(status)} me-3`, className)}>
      {formatMessage({ id: `priceImprovement.status.${status}` as IntlKey })}
    </span>
  );
};

function toColor(status: PriceImprovementStatus): Color {
  switch (status) {
    case 'Cancelling':
    case 'Pending':
      return 'warning';
    case 'Rejected':
      return 'danger';
    case 'Expired':
    case 'Cancelled':
      return 'secondary';
    case 'Validated':
      return 'success';
    default:
      return 'info';
  }
}
